export enum PostHogFeatureFlags {
  TwoMonthFreeUKOLR = '2-months-free-uk-olr',
  OOGPanelUKOLR = 'oog-panel-uk-olr',
  GuaranteeVsDG = 'uk-guarantee-vs-dg',
  CroExperiment = 'cro-experiment',
}
